import React from "react";
import { Quote } from "lucide-react";
import { testimonials } from "../mock";
import { useLanguage } from "../contexts/LanguageContext";

const Testimonials = () => {
  const { t } = useLanguage();
  const { prefix, highlight, suffix } = t.testimonials.titleParts;

  return (
    <section className="mag-testimonials">
      <div className="mag-section-heading">
        <h2 style={{ color: "#ea6161" }}>
          {prefix}
          <span>{highlight}</span>
          {suffix}
        </h2>
        <div className="mag-underline-red" />
      </div>
      <div className="mag-testimonials-grid">
        {testimonials.map((item) => {
          const data = t.testimonials[item.key];
          return (
            <div key={item.id} className="mag-testimonial reveal">
              <div className="mag-testimonial-quote">
                <Quote size={28} />
              </div>
              <p className="mag-testimonial-text">“{data.quote}”</p>
              <div className="mag-testimonial-author">
                <div className="mag-testimonial-avatar">{item.initials}</div>
                <div>
                  <div className="mag-testimonial-name">{item.name}</div>
                  <div className="mag-testimonial-role">{data.role}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Testimonials;
